const Users = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.99982 2C6.51453 2 4.49982 4.01472 4.49982 6.5C4.49982 8.98528 6.51453 11 8.99982 11C11.4851 11 13.4998 8.98528 13.4998 6.5C13.4998 4.01472 11.4851 2 8.99982 2Z"
      fill="currentColor"
    />
    <path
      d="M14.9998 2C14.4475 2 13.9998 2.44772 13.9998 3C13.9998 3.55228 14.4475 4 14.9998 4C16.3805 4 17.4998 5.11929 17.4998 6.5C17.4998 7.88071 16.3805 9 14.9998 9C14.4475 9 13.9998 9.44772 13.9998 10C13.9998 10.5523 14.4475 11 14.9998 11C17.4851 11 19.4998 8.98528 19.4998 6.5C19.4998 4.01472 17.4851 2 14.9998 2Z"
      fill="currentColor"
    />
    <path
      d="M8.99982 12C4.57047 12 0.738567 14.879 0.0931751 18.8433C-0.112525 20.1068 0.947937 21 1.99982 21H15.9998C17.0517 21 18.1122 20.1068 17.9065 18.8433C17.2611 14.879 13.4292 12 8.99982 12Z"
      fill="currentColor"
    />
    <path
      d="M18.3337 12.5662C17.8131 12.3818 17.2416 12.6543 17.0572 13.1749C16.8728 13.6955 17.1454 14.267 17.6659 14.4514C19.9135 15.2475 21.5072 16.986 21.9029 19H20.4998C19.9475 19 19.4998 19.4477 19.4998 20C19.4998 20.5522 19.9475 21 20.4998 21H21.9998C23.0515 21 24.1122 20.107 23.9065 18.8434C23.4314 15.9247 21.2138 13.5863 18.3337 12.5662Z"
      fill="currentColor"
    />
  </svg>
)

export default Users
